// extracted by mini-css-extract-plugin
export default {"linkRow":"AdditionalCourseDiscountLabel_linkRow__2vsCq","link":"AdditionalCourseDiscountLabel_link__5mHwP"};